import axios from 'axios';
import { config } from '../../Configs';

export const SendPhoneCodeAPI = async (
  phone,
  phoneCountryCode,
  token = null,
  recaptchaToken = null,
  otpChannels = null
) => {
  try {
    const configObj = {
      headers: {
        Authorization: token
      },
      params: { 'g-recaptcha-response': recaptchaToken }
    };

    const body = { phoneCountryCode, phone };
    if (otpChannels) {
      body.otpChannels = {
        sms: Boolean(otpChannels.sms),
        whatsapp: Boolean(otpChannels.whatsapp)
      };
    }

    const response = await axios.post(
      `${config.api.url}/phoneValidation/sendPhoneCode`,
      body,
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const VerifyPhoneCodeAPI = async ({
  code,
  phoneCountryCode,
  phone,
  email = null,
  token = null,
  recaptchaToken = null,
  passwordChangeRequired = false
}) => {
  try {
    const configObj = {
      headers: {
        Authorization: token
      },
      params: { 'g-recaptcha-response': recaptchaToken }
    };

    const payload = {
      code,
      phoneCountryCode,
      phone
    };
    if (email) {
      payload.email = email;
    }

    if (passwordChangeRequired) {
      payload.passwordChangeRequired = passwordChangeRequired;
    }

    const response = await axios.post(
      `${config.api.url}/phoneValidation/verifyPhoneCode`,
      payload,
      configObj
    );
    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};

export const ResendPhoneCodeAPI = async (email, recaptchaToken = null) => {
  try {
    const configObj = {
      params: { 'g-recaptcha-response': recaptchaToken }
    };

    const response = await axios.post(
      `${config.api.url}/phoneValidation/resendPhoneCode`,
      { email },
      configObj
    );

    return { success: true, data: response.data };
  } catch (err) {
    return { success: false, error: err };
  }
};
